/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Import_Subtitles_Complete_ToastInputs */



/**
* | output |
* | --- |
* | "Subtitle import complete" |
*
* @param {Editor_Import_Subtitles_Complete_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_import_subtitles_complete_toast = /** @type {((inputs?: Editor_Import_Subtitles_Complete_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Import_Subtitles_Complete_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation des sous-titres terminee")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitelimport abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione sottotitoli completata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт субтитров завершен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación de subtítulos completada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕导入完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕のインポートが完了しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक आयात पूर्ण हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação de legendas concluída")
	return /** @type {LocalizedString} */ ("Subtitle import complete")
});